import React from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

export const MainLayout: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh', background: 'transparent' }}>
      <Layout style={{ background: 'transparent' }}>
        <Content
          style={{
            margin: 0,
            padding: 0,
            minHeight: '100vh',
            position: 'relative',
            width: '100%'
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
